const settingsSwedish = {
  header: {
    title: "LinkedIn Inställningar",
    description: "Anslut ditt LinkedIn-konto för att få tillgång till systemet",
    descriptionEmployee: "Anslut dina konton för att komma igång"
  },
  messages: {
    success: "Framgång!",
    error: "Ett fel uppstod",
    closeButton: "Stäng"
  },
  linkedin: {
    title: "LinkedIn Profil",
    loading: "Laddar...",
    connected: "LinkedIn-profil ansluten",
    description: "Anslut din LinkedIn-profil för att skapa inlägg",
    connectButton: "Anslut LinkedIn",
    disconnectButton: "Koppla bort LinkedIn",
    profileInfo: {
      unnamed: "Namnlös användare",
      status: "Status:",
      active: "Aktiv",
      expires: "Går ut:",
      expiresIn: "Om {days} dagar",
      unknown: "Okänd",
      noProfileData: "Kunde inte hämta profildata. Försök koppla bort och ansluta igen."
    }
  },
  telegram: {
    title: "Telegram Bot",
    description: "Anslut Telegram för att generera och ta emot LinkedIn-inlägg direkt",
    connected: "Telegram är ansluten",
    connectButton: "Anslut Telegram",
    disconnectButton: "Koppla bort Telegram",
    generating: "Genererar kod...",
    connectionGuide: {
      title: "Så här ansluter du Telegram",
      steps: [
        "Öppna Telegram och sök efter NuvikAI_bot",
        "Starta botten genom att skriva /start",
        "Skicka denna kod till botten:"
      ],
      expires: "Koden går ut om 15 minuter"
    }
  },
  deliverySettings: {
    title: "Leveransinställningar",
    description: "Välj var du vill ta emot dina veckovisa AI-genererade LinkedIn-inlägg",
    options: {
      website: "På webbplatsen",
      telegram: "Via Telegram"
    },
    helpText: {
      website: "Dina inlägg kommer att visas i \"LinkedIn AI Generator\"-avsnittet i appen.",
      telegram: "Dina inlägg skickas direkt till dig via Telegram."
    }
  },
  readyCard: {
    title: "Allt är klart!",
    description: "Du kan nu använda Telegram för att generera och publicera LinkedIn-inlägg, eller se dina genererade inlägg direkt i appen.",
    viewPostsButton: "Se dina inlägg"
  },
  customerSuccess: {
    title: "LinkedIn-kontot är anslutet!",
    description: "Ditt LinkedIn-konto är nu anslutet. Du kommer nu att få innehåll från systemet som kommer att delas på din LinkedIn-profil."
  },
  language: {
    title: "Språk",
    description: "Välj ditt föredragna språk"
  }
};

export default settingsSwedish; 